export * from "./Square.mjs";
export * from "./Circle.mjs";
export * from "./getShapeSize.mjs";
//# sourceMappingURL=index.mjs.map
